// API Configuration
// In development, use empty baseURL so proxy middleware intercepts requests
// In production, use full URL for direct access
const isDevelopment = process.env.NODE_ENV === "development";

export const API_CONFIG = {
  baseURL: "",
  apiPath: "/api",
  timeout: 45000,
};

// Helper function to construct API endpoints
export const getApiUrl = (endpoint: string): string => {
  // Remove leading slash if present
  const cleanEndpoint = endpoint.startsWith("/") ? endpoint.slice(1) : endpoint;
  return `${API_CONFIG.apiPath}/${cleanEndpoint}`;
};

// API Endpoints
export const API_ENDPOINTS = {
  // Auth endpoints
  auth: {
    login: getApiUrl("auth/login"),
    register: getApiUrl("auth/register"),
    refresh: getApiUrl("auth/refresh"),
    logout: getApiUrl("auth/logout"),
    verifyMFA: getApiUrl("auth/mfa/verify"),
    resendPhone: getApiUrl("auth/resend/phone"),
    resendEmail: getApiUrl("auth/resend/email"),
  },

  // Password endpoints
  password: {
    forgot: getApiUrl("password/forgot"),
    reset: getApiUrl("password/reset"),
  },

  // Account endpoints
  account: {
    mfaInitiate: getApiUrl("account/mfa/initiate"),
    mfaVerify: getApiUrl("account/mfa/verify"),
    emailResend: getApiUrl("account/verification/email/resend"),
    phoneInitiate: getApiUrl("account/verification/phone/initiate"),
    phoneConfirm: getApiUrl("account/verification/phone/confirm"),
  },

  // User endpoints
  users: {
    activate: getApiUrl("users/activate"),
  },

  // Verification endpoints
  verify: {
    emailConfirm: getApiUrl("verify/email/confirm"),
  },

  // Summary endpoints
  summary: {
    all: getApiUrl("summary/allSummary"),
  },

  // File endpoints
  files: {
    upload: getApiUrl("files/upload"),
    uploadClaims: getApiUrl("files/upload/claims"),
  },

  // Organisation endpoints
  organisations: {
    get: (name: string) => getApiUrl(`organisations/byName/${name}`),
    update: (id: string) => getApiUrl(`organisations/${id}`),
  },
};
